import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { MessageCircle } from "lucide-react";
import { Navbar } from "./sections/Navbar";
import { Hero } from "./sections/Hero";
import { TrustBar } from "./sections/TrustBar";
import { About } from "./sections/About";
import { WhyUs } from "./sections/WhyUs";
import { Collections } from "./sections/Collections";
import { Gallery } from "./sections/Gallery";
import { Directors } from "./sections/Directors";
import { Marquee } from "./sections/Marquee";
import { Instagram } from "./sections/Instagram";
import { Reviews } from "./sections/Reviews";
import { Showroom } from "./sections/Showroom";
import { VisionBanner } from "./sections/VisionBanner";
import { GoldExchange } from "./sections/GoldExchange";
import { MakingCharges } from "./sections/MakingCharges";
import { Contact } from "./sections/Contact";
import { EnquiryForm } from "./sections/EnquiryForm";
import { FAQ } from "./sections/FAQ";
import { Footer } from "./sections/Footer";
import { BUSINESS } from "./data/content";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-ivory">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <About />
        <WhyUs />
        <Collections />
        <Gallery />
        <Directors />
        <Marquee />
        <Instagram />
        <Reviews />
        <Showroom />
        <VisionBanner />
        <GoldExchange />
        <MakingCharges />
        <Contact />
        <EnquiryForm />
        <FAQ />
      </main>
      <Footer />

      <a
        data-testid="floating-whatsapp-button"
        href={BUSINESS.whatsappHref}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-gold text-royal-deep flex items-center justify-center shadow-[0_10px_30px_rgba(6,48,35,0.35)] hover:bg-gold-light hover:scale-105 transition-[background-color,transform] duration-300"
      >
        <MessageCircle size={22} strokeWidth={1.6} />
      </a>

      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
